/* eslint-disable camelcase */
import React, { memo } from 'react'

import { useSelector } from 'react-redux'
import moment from 'moment'
import styled from 'styled-components'
import { FaSmile } from 'react-icons/fa'

import { P } from '../../../style/Typography.style'

import useFetch from '../../../hooks/useFetch'

import { sortByNewestFirst } from '../../../constant/sortBy'

const POCNotes = () => {
  const { talent } = useSelector((state) => state.talents)
  const { selectedInterview } = useSelector((state) => state.requisitions)

  const { data, loading } = useFetch(
    `/notes?applicant_id=${talent?.id}&job_id=${selectedInterview?.job_id}`
  )

  if (loading) return <P>Loading...</P>

  return (
    <StyledPOCNotes>
      {data && data?.resp?.length > 0 ? (
        data.resp
          .sort(sortByNewestFirst)
          .map(({ created_at, id: noteID, note_author, notes }) => (
            <StyledNote key={noteID}>
              {/* <img src={smiley} alt="smiley face" /> */}
              <FaSmile className="avatar" />

              <div className="details">
                <P size="0.75rem" weight="500">
                  {note_author}
                </P>
                <P size="0.75rem" weight="300">
                  {moment(created_at).format('MMMM Do, YYYY')} {' at '}
                  {moment(created_at).format('h:mm A')}
                </P>
                <P
                  marginTop="0.75rem"
                  size="0.75rem"
                  weight="300"
                  dangerouslySetInnerHTML={{ __html: JSON.parse(notes)[0] }}
                />
              </div>
            </StyledNote>
          ))
      ) : (
        <P>No POC notes to display at the moment</P>
      )}
    </StyledPOCNotes>
  )
}

export default memo(POCNotes)

export const StyledPOCNotes = styled.section`
  width: 100%;
  padding: 0 0 1rem 0;
  min-height: 60px;

  .avatar {
    color: #ff7b9b;
    font-size: 36px;
  }
`

const StyledNote = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 1rem;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`
